import React from 'react';
import useTranslation from 'shared/hooks/useTranslation';
import styled from 'styled-components';
import { COLORS } from 'config/theme';

type ButtonProps = {
  isLight: boolean;
};

const StyledButton = styled.button<ButtonProps>`
  background: none;
  border: none;
  font-size: 16px;
  color: ${({ isLight }) => (isLight ? 'white' : COLORS.PRIMARY)};
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
`;

const BokEmail = styled.a`
  unicode-bidi: bidi-override;
  direction: rtl;
  color: ${COLORS.PRIMARY};
`;

type EmailProps = {
  email: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  isLight?: boolean;
  color?: string;
};

export default function Email({ email, visible, setVisible, isLight = false, color = 'blue' }: EmailProps): JSX.Element | null {
  const { t } = useTranslation('common');
  return visible ? (
    <BokEmail style={{ color }} href={`mailto: ${email.split('').reverse().join('')}`}>{email}</BokEmail>
  ) : (
    <StyledButton role="button" isLight={isLight} onClick={() => setVisible(true)} style={{ color }}>
      {t('showEmail')}
    </StyledButton>
  );
}
